import { api } from "../../lib/api";
export const updateProjectDetails = async (partyNumber, projectId, projectStatus, updateProjectDetailsRequest) => {
    const config = { params: { ...(partyNumber && { partyNumber }), ...(projectStatus && { projectStatus }) } };
    const { data } = await api.patch(`/projects/${projectId}`, updateProjectDetailsRequest, config);
    return { data };
};
